import React from "react";
import { Link } from "gatsby";
import Modal from "react-bootstrap/Modal";
import { StaticImage } from "gatsby-plugin-image";

// mixpanel
import {
  trackNavLinkClick,
  trackCTAClick,
  trackLogoClick,
} from "./headerMixpanel";

// styles
import * as styles from "./NewTogglerModal.module.css";

const NewTogglerModal = props => {
  const { show, onHide, navItems, currentPath, ctaButtons, mixpanelConfig } = props;

  return (
    <Modal
      show={show}
      onHide={onHide}
      backdrop="static"
      keyboard={false}
      bsPrefix="right_modal modal"
      dialogClassName={styles.modalDialog}
    >
      <Modal.Header closeButton className={styles.modalHeader}>
        <div className={styles.modalLogo}>
          <Link
            to="/"
            onClick={() => {
              trackLogoClick(mixpanelConfig.locations.mobileMenu, currentPath);
              onHide();
            }}
          >
            <StaticImage
              src="../../images/twin-logo/twin_new_logo.png"
              alt="Twin Health India Logo"
              placeholder="blurred"
              className={styles.logoImage}
              quality={90}
            />
          </Link>
        </div>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <div className={styles.menuContent}>
          {/* Navigation Links */}
          <ul className={styles.navList} role="presentation">
            {navItems.map((item, index) => {
              const isActive = currentPath === item.link;
              return (
                <li key={index}>
                  <Link
                    to={item.link}
                    className={`${styles.navLink} ${
                      isActive ? styles.activeNavLink : ""
                    }`}
                    onClick={() => {
                      trackNavLinkClick(
                        item.label,
                        mixpanelConfig.locations.mobileMenu,
                        currentPath
                      );
                      onHide();
                    }}
                  >
                    {item.label}
                  </Link>
                </li>
              );
            })}
            <li>
              <Link
                to={ctaButtons.enroll.link}
                className={`${styles.navLink} ${
                  currentPath === ctaButtons.enroll.link
                    ? styles.activeNavLink
                    : ""
                }`}
                onClick={() => {
                  trackCTAClick(
                    ctaButtons.enroll.label,
                    mixpanelConfig.locations.mobileMenu,
                    currentPath
                  );
                  onHide();
                }}
              >
                {ctaButtons.enroll.label}
              </Link>
            </li>
          </ul>

          {/* CTA Buttons */}
          <div className={styles.ctaSection}>
            <Link
              to={ctaButtons.contact.link}
              className={styles.contactBtn}
              onClick={() => {
                trackCTAClick(
                  ctaButtons.contact.label,
                  mixpanelConfig.locations.mobileMenu,
                  currentPath
                );
                onHide();
              }}
            >
              {ctaButtons.contact.label}
            </Link>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewTogglerModal;
